import { render } from "./VehicleComponent.vue?vue&type=template&id=d302a664&scoped=true"
const script = {}

import "./VehicleComponent.vue?vue&type=style&index=0&id=d302a664&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d302a664"]])

export default __exports__